var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"loading":!_vm.content.thumbnail,"type":"card","transition":"scale-transition"}},[_c('v-card',{staticClass:"ma-0 pa-0",attrs:{"max-width":"220"}},[_c('v-card-text',{staticClass:"pa-0 ma-0"},[(_vm.content.type.startsWith('image/'))?_c('v-img',{attrs:{"src":_vm.thumbnail}}):_vm._e(),(_vm.content.type.startsWith('video/'))?_c('video-player',{ref:"player",attrs:{"source":_vm.source,"poster":_vm.thumbnail,"options":{
          autoplay: false,
          controls: true,
          fluid: true,
          responsive: true
        }}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }